<i class="fa fa-spinner fa-spin loader" *ngIf="loadingSite"></i>
<div class="content-wrapper">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <section id="page-account-settings">
      <button class="back-button" (click)="goBack()"><i data-feather="arrow-left"
          class="font-medium-3 mr-1"></i>Back</button>
      <div id="demo" *ngIf="assignmentData.length !== 0">
        <div class="header">
          <div class="header-container">
            <div class="col-12">
              <div class="d-flex justify-content-end"><button class="btn-sm btn-primary" [useExistingCss]="true" printSectionId="demo"
                  ngxPrint>Export to PDF</button></div>
            </div>
            <!-- <div class="text-right">
              <p>Regency at Augusta - Friday April 11 2025</p>
              <h4>ShifTrak Schedule</h4>
            </div> -->
          </div>
        </div>
        <div class="card mb-3">
        <div class="shift-container" *ngFor="let rate of assignmentData">
            <div class="card-header btn-primary">
              <h3 class="mb-0 text-white">Shift: {{ rate.shiftTime }}</h3>
            </div>
            <div class="card-body">
              <table class="table table-bordered shift-table">
                <!-- <thead>
                  <tr>
                    <th colspan="2">{{ rate.schedule[0]?.positions }}</th>
                  </tr>
                </thead> -->
                <thead>
                  <tr>
                    <th>Position</th>
                    <th>assignment</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let shifts of rate.schedule">
                    <td>{{ shifts.positions || '' }}</td>
                    <td>{{ shifts.assignment || '' }}</td>
                    <td [ngClass]="{ 'yellow-name': shifts.assigned === 0 }">
                      {{ shifts.assigned === 0 ? 'Posted' : (shifts.first_name || '') + ' ' + (shifts.user_lastname || '') }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        
      </div>
    </section>
    <div class="card mb-3" *ngIf="assignmentData.length == 0">
      <div class="card-body">
        <div class="empty" >No Data Found</div>
      </div>
    </div>

  </div>
</div>
